import gql from "graphql-tag";

export const NUTRITION_PLANS_QUERY = gql`
  query nutritionPlans {
    nutritionPlans {
      id
      name
    }
  }
`;

export const UPDATE_NUTRITION_PLAN_MUTATION = gql`
  mutation updateNutritionPlanMutation($userId: ID!, $nutritionPlanId: ID!) {
    updateNutritionPlan(userId: $userId, nutritionPlanId: $nutritionPlanId) {
      updated
      error
    }
  }
`;

export const NUTRITION_LOG_DETAIL_QUERY = gql`
  query nutritionQuery($startDate: Date!, $endDate: Date!, $userId: ID!) {
    nutritionLog(date_Lte: $endDate, date_Gte: $startDate, userId: $userId) {
      edges {
        node {
          id
          date
          comments
          onTrack
          flexiMeal
          image
          computedImage
          meal
          customTitle
          coachComment
          createdAt
          recipe {
            id
            title
            image
            meal
          }
          subscriptionRecipe {
            id
            meal
            recipe {
              id
              title
              image
              meal
            }
          }
          totalQuestions
          truthyQuestions
          usernutritionloganswerSet {
            id
            answer
            nutritionQuestion {
              id
              question
              title
            }
          }
        }
      }
    }
    user(id: $userId) {
      id
      userProfile {
        id
        calculatedServingSize
        coachingChat {
          id
        }
      }
    }
  }
`;

export const NUTRITION_DAY_RATING_QUERY = gql`
  query nutritionDayRatings($date_Gte: Date!, $date_Lte: Date!, $userId: ID!) {
    nutritionDayRatings(date_Gte: $date_Gte, date_Lte: $date_Lte, userId: $userId) {
      edges {
        node {
          id
          date
          rating
          text
        }
      }
    }
  }
`;
